import { Box, Button, Typography } from "@mui/material";
import { useEffect, useState } from "react";

export default function CookieNotice() {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const accepted = localStorage.getItem("cookiesAccepted");
        if (!accepted) {
            setOpen(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem("cookiesAccepted", "true");
        setOpen(false);
    };

    if (!open) return null;

    return (
        <Box
            sx={{
                position: "fixed",
                bottom: 20,
                left: {
                    xs: 12,
                    sm: 20,
                },
                right: {
                    xs: 12, // No celular ocupa quase toda a largura
                    sm: "auto",
                },
                zIndex: 9999,

                display: "flex",
                alignItems: {
                    xs: "flex-start",
                    sm: "center",
                },
                flexDirection: {
                    xs: "column",
                    sm: "row",
                },
                gap: 1.5,

                p: 2,

                width: {
                    xs: "auto",
                    sm: 360,
                },

                bgcolor: "rgba(20,20,20,.95)",
                color: "#fff",
                border: "1px solid rgba(255,255,255,.08)",
                borderRadius: 3,
                backdropFilter: "blur(12px)",
                boxShadow: "0 10px 30px rgba(0,0,0,.25)",
            }}
        >
            <Typography
                variant="body2"
                sx={{
                    lineHeight: 1.5,
                }}
            >
                🍪 Utilizamos cookies para melhorar sua experiência de navegação.
            </Typography>

            <Button
                variant="outlined"
                size="small"
                onClick={handleAccept}
                sx={{
                    textTransform: "none",
                    borderRadius: 2,
                    alignSelf: {
                        xs: "stretch",
                        sm: "center",
                    },
                }}
            >
                OK
            </Button>
        </Box>
    );
}